import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * StatusPill, the soft-tint status pill.
 *
 * CSS selector: `mobile/atoms.css` `.ds-status` (+ `--info`, `--success`,
 * `--warning`, `--error`, `--accent`).
 *
 * Doctrine: every tone runs through the same standardised tint recipe, sharing
 * the two amounts held in `tokens.css`. Never invent a one-off percentage, and
 * never give a status a flat saturated fill; status is information, not command.
 *
 * `accent` is the brand-status flavour used by the order lifecycle (Ordered,
 * Shipped, Delivered). It is allowed to reference the accent because it stands
 * for progress state, which is exactly what accent is for.
 */
const STATUS_TONE = {
  info: 'ds-status--info',
  success: 'ds-status--success',
  warning: 'ds-status--warning',
  error: 'ds-status--error',
  accent: 'ds-status--accent',
};

export const StatusPill = React.forwardRef(function StatusPill(
  { className, tone = 'info', ...rest },
  ref,
) {
  return <span ref={ref} className={cn('ds-status', STATUS_TONE[tone], className)} {...rest} />;
});

export default StatusPill;
